module.exports = __webpack_public_path__ + "media/assets/logo-7b33cb058bbcbb624a81dbee93bb2064.svg";